import axios from 'axios';

import {
    SupersetCSRFTokenResponse,
    SupersetGuestTokenRequest,
    SupersetGuestTokenResponse,
    SupersetLoginRequest,
    SupersetLoginResponse
} from 'models/Superset';

const SUPERSET_BASE = 'https://athena.focusonesoftware.com';
const SUPERSET_PASS = 'AG1q2w3e4r';
const SUPERSET_ADMIN = 'embedded';

async function loginAsync(credentials?: SupersetLoginRequest) {
    const response = await axios.post<SupersetLoginResponse>(
        `${SUPERSET_BASE}/api/v1/security/login`,
        credentials
            ? credentials
            : {
                  provider: 'db',
                  username: SUPERSET_ADMIN,
                  password: SUPERSET_PASS,
                  refresh: true
              }
    );

    return response.data;
}

async function getCSFRTokenAsync(accessToken: string) {
    const uri = `${SUPERSET_BASE}/api/v1/security/csrf_token/`;

    const response = await axios.get<SupersetCSRFTokenResponse>(uri, {
        headers: {
            Authorization: `Bearer ${accessToken}`
        }
    });

    return {
        csfrToken: response.data.result,
        referer: uri
    };
}

async function getGuestTokenAsync(request: SupersetGuestTokenRequest) {
    const clauses =
        request.rls?.map(item => ({
            clause: item.clause,
            dataset: item.dataset
        })) ?? [];

    const response = await axios.post<SupersetGuestTokenResponse>(
        `${SUPERSET_BASE}/api/v1/security/guest_token/`,
        {
            resources: [
                {
                    type: 'dashboard',
                    id: request.uuid
                }
            ],
            rls: clauses,
            user: {
                username: SUPERSET_ADMIN,
                first_name: SUPERSET_ADMIN,
                last_name: SUPERSET_ADMIN
            }
        },
        {
            headers: {
                Authorization: `Bearer ${request.accessToken}`,
                'X-CSRFToken': request.csfrToken,
                Referer: request.referer
            }
        }
    );

    return response.data;
}

export const SupersetAPI = Object.assign(
    {},
    {
        SUPERSET_BASE,
        SUPERSET_ADMIN,
        SUPERSET_PASS,
        loginAsync,
        getCSFRTokenAsync,
        getGuestTokenAsync
    }
);
